import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { logPrivacyAudit } from "@/lib/privacyAudit";

// Log verifiable privacy and security architecture audit for DevTools inspectors
logPrivacyAudit();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
